export enum AirQualityColorsEnum {
  EMPTY_INDEX = '#bfbfbf',
  VERY_BAD = '#990000',
  BAD = '#e50000',
  SUFFICIENT = '#e58100',
  MEDIUM = '#ffd911',
  GOOD = '#b0dd10',
  VERY_GOOD = '#57b108',
}
